<template>
    <div>
       <ChooseButtonComponent 
            :buttons="buttonsQuestionAlcohol"
            v-on:choose-button="getValueQuestionAlcohol($event)"
            label="¿Consume bebidas alcohólicas?" 
            :buttons_styles="buttons_styles"
        />

        <div :class="view_class_view.div_container_error.container" v-for="(error,index) of alcoholConsumptionModelValidations.consumes.$errors" :key="index">
            <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
        </div> 
        
        <div v-show="alcoholConsumptionModel.consumes == 'Sí'" class="grid grid-cols-1 mb-10">
            <div class="mt-10">
                <p class="label-input w-full">¿Qué clase?</p>

                <select name="select_consumes" id="select_consumes"
                    v-model="alcoholConsumptionModelValidations.you_consumes.$model"
                    :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: alcoholConsumptionModelValidations.you_consumes.$error,
                    [view_class_view.classInputs.default + view_class_view.classInputs.valid]: !alcoholConsumptionModelValidations.you_consumes.$invalid,
                    [view_class_view.classInputs.default ]: alcoholConsumptionModelValidations.you_consumes.$invalid && !alcoholConsumptionModelValidations.you_consumes.$error }"
                    @blur="alcoholConsumptionModelValidations.you_consumes.$validate" >
                    <option v-for="(alcohol_type, index) in alcoholTypeList" :value="alcohol_type.value" :key="index"> {{ alcohol_type.text }}</option>
                </select>
        
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of alcoholConsumptionModelValidations.you_consumes.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="mt-10">
                <p class="label-input w-full">Cantidad:</p>

                <select name="select_quantity" id="select_quantity"
                    v-model="alcoholConsumptionModelValidations.quantity.$model"
                    :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: alcoholConsumptionModelValidations.quantity.$error,
                    [view_class_view.classInputs.default + view_class_view.classInputs.valid]: !alcoholConsumptionModelValidations.quantity.$invalid,
                    [view_class_view.classInputs.default ]: alcoholConsumptionModelValidations.quantity.$invalid && !alcoholConsumptionModelValidations.quantity.$error }"
                    @blur="alcoholConsumptionModelValidations.quantity.$validate" >
                    <option v-for="(alcohol_quantity, index) in quantityAlcoholList" :value="alcohol_quantity.value" :key="index"> {{ alcohol_quantity.text }}</option>
                </select>
        
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of alcoholConsumptionModelValidations.quantity.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="mt-10">
                <p class="label-input w-full">Frecuencia:</p>

                <select name="select_frecuency" id="select_frecuency"
                    v-model="alcoholConsumptionModelValidations.frecuency.$model"
                    :class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: alcoholConsumptionModelValidations.frecuency.$error,
                    [view_class_view.classInputs.default + view_class_view.classInputs.valid]: !alcoholConsumptionModelValidations.frecuency.$invalid,
                    [view_class_view.classInputs.default ]: alcoholConsumptionModelValidations.frecuency.$invalid && !alcoholConsumptionModelValidations.frecuency.$error }"
                    @blur="alcoholConsumptionModelValidations.frecuency.$validate" >
                    <option v-for="(alcohol_frecuency, index) in frecuencyAlcoholList" :value="alcohol_frecuency.value" :key="index"> {{ alcohol_frecuency.text }}</option>
                </select>
        
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of alcoholConsumptionModelValidations.frecuency.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

            <div class="mt-10">
                <p class="label-input w-full">Si ha dejado de beber especifique que fecha:</p>

                <date-picker
                    class="block mt-2"
                    value="11/11/1995"
                    simple
                    placeholder="Fecha inicio"
                    locale="es"
                    v-model="alcoholConsumptionModelValidations.completion_date.$model"
                    format="YYYY/MM/DD"
                    id="input_completion_date"
                    :localeConfig="{
                      es: {
                        displayFormat: 'YYYY/MM/DD',
                          lang: {
                            year: 'Año',
                            month: 'Mes',
                            day: 'Día',
                            label: '',
                            submit: 'Seleccionar',
                            cancel: 'Cancelar',
                            now: 'Hoy',
                            nextMonth: 'Siguiente',
                            prevMonth: 'Anterior',
                          },
                        }
                    }" />
        
                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of alcoholConsumptionModelValidations.completion_date.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div> 
            </div>

        </div>

    </div>

</template>

<script>

import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import ChooseButtonComponent from './../Forms/ChooseButton.vue';

export default {
    props: {
        buttonsQuestionAlcohol: {
            type: Array,
            required: true,
            default(){
                return [];
            }
        },
        alcoholTypeList: {
            type: Array,
            required: true,
            default(){
                return [];
            }
        },
        quantityAlcoholList: {
            type: Array,
            required: true,
            default(){
                return [];
            }
        },
        frecuencyAlcoholList: {
            type: Array,
            required: true,
            default(){
                return [];
            }
        },
        validations:{
            type: Object,
            default(){
                return {};
            }
        },
        view_class_view:{
            type: Object,
            default(){
                return {};
            }
        },
        buttons_styles: {
            type: Object,
            default(){
                return {};
            }
        },
    },
    setup(props) {
        
        let alcoholConsumptionModel  = ref({
            consumes: "",
            you_consumes: "",
            quantity: "",
            frecuency: "",
            completion_date: ""
        });

        let alcoholConsumptionModelValidations = useVuelidate(props.validations, alcoholConsumptionModel)
        
        function getValueQuestionAlcohol(value) {
            alcoholConsumptionModel.value.consumes = value;

            if(alcoholConsumptionModel.value == null) return;
            alcoholConsumptionModelValidations.value.you_consumes.$model = "";
            alcoholConsumptionModelValidations.value.quantity.$model = "";
            alcoholConsumptionModelValidations.value.frecuency.$model = "";
            alcoholConsumptionModelValidations.value.completion_date.$model = "";
            alcoholConsumptionModelValidations.value.$reset();
        }

        function selectDateAlcohol(value){
            alcoholConsumptionModel.value.completion_date = value;
        }

        function consumptionSelectLastDate(value){
            alcoholConsumptionModel.value.narcotics.last_consumption_date = value;
        }

        function execute_validation() {
            alcoholConsumptionModelValidations.value.$validate();
            if(alcoholConsumptionModelValidations.value.$error){
                return false;
            }

            return alcoholConsumptionModel.value;
        }

        return {
            alcoholConsumptionModel,
            alcoholConsumptionModelValidations,
            getValueQuestionAlcohol,
            selectDateAlcohol,
            consumptionSelectLastDate,
            execute_validation
        };
    },
    components: {
        ChooseButtonComponent
    }
}
</script>